export const API_ENDPOINTS = {
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  addRoute: "/manage-sidebar/new",
  allRoutes: "/manage-sidebar/all",
  singleRoutes: "/manage-sidebar/one",
  editRoute: "/manage-sidebar/update",
  deleteRoute: "/manage-sidebar/delete",
  featuredStatus: "/product_featured",
  addCatalogL1: "/addCatalog",
  catalogsL1: "/catalogs",
  singleCatalogL1: "/singleCatalog",
  updateCatalogL1: "/updateCatalog",
  deleteCatalogL1: "/deleteCatalog",
  addCatalogL2: "/addCatalog2",
  catalogsL2: "/catalogs2",
  singleCatalogL2: "/singleCatalog2",
  updateCatalogL2: "/updateCatalog2",
  deleteCatalogL2: "/deleteCatalog2",
  filterSubCategory: "/selectedcategories",
  filterSubChildCategory: "/selectedsubcategories",
  addCatalogL3: "/addCatalog3",
  catalogL3: "/catalogs3",
  singleCatalogL3: "/singleCatalog3",
  updateCatalogL3: "/updateCatalog3",
  deleteCatalogL3: "/deleteCatalog3",
  addChemical: "/addChemical",
  chemicals: "/chemicals",
  singleChemical: "/singleChemical",
  updateChemical: "/updateChemical",
  deleteChemical: "/deleteChemical",
  dublicateChemical: "/duplicateChemical",
  chemicalInStock: "/chemicalInStock",
  createUtility: "/updateUtility",
  getUtilityEndpoint: "/getUtility",
  createBanner: "/banner",
  getBanner: "/banner",
  createCompanyMission: "/companymission",
  getCompanyMission: "/companymission",
  createSeviceheading: "/seviceheading",
  getSeviceheading: "/seviceheading",
  addService: "/service",
  allServices: "/service/all",
  singleService: "/service/show",
  updateServices: "/service/update",
  deleteService: "/service/delete",
  // Partner Services Endpoints
  addPartnerService: "/partner-services",
  getAllPartnerServices: "/partner-services/all",
  getSinglePartnerService: "/partner-services/show",
  updatePartnerService: "/partner-services/update",
  deletePartnerService: "/partner-services/delete",
  togglePartnerServiceStatus: "/partner-services/toggle-status",
  // Custom Synthesis CRO Services (homepage section) Endpoints
  getCustomSynthesisCro: "/custom-synthesis-cro",
  updateCustomSynthesisCro: "/custom-synthesis-cro",
  getAllCustomSynthesisCroTags: "/custom-synthesis-cro/tags/all",
  addCustomSynthesisCroTag: "/custom-synthesis-cro/tags",
  updateCustomSynthesisCroTag: "/custom-synthesis-cro/tags",
  deleteCustomSynthesisCroTag: "/custom-synthesis-cro/tags",
  getAllCustomSynthesisCroFaqs: "/custom-synthesis-cro/faqs/all",
  addCustomSynthesisCroFaq: "/custom-synthesis-cro/faqs",
  updateCustomSynthesisCroFaq: "/custom-synthesis-cro/faqs",
  deleteCustomSynthesisCroFaq: "/custom-synthesis-cro/faqs",
  // Medicinal Chemistry CRO Services (homepage section) Endpoints
  getMedicinalChemistryCro: "/medicinal-chemistry-cro",
  updateMedicinalChemistryCro: "/medicinal-chemistry-cro",
  getAllMedicinalChemistryCroTags: "/medicinal-chemistry-cro/tags/all",
  addMedicinalChemistryCroTag: "/medicinal-chemistry-cro/tags",
  updateMedicinalChemistryCroTag: "/medicinal-chemistry-cro/tags",
  deleteMedicinalChemistryCroTag: "/medicinal-chemistry-cro/tags",
  getAllMedicinalChemistryCroFaqs: "/medicinal-chemistry-cro/faqs/all",
  addMedicinalChemistryCroFaq: "/medicinal-chemistry-cro/faqs",
  updateMedicinalChemistryCroFaq: "/medicinal-chemistry-cro/faqs",
  deleteMedicinalChemistryCroFaq: "/medicinal-chemistry-cro/faqs",
  // Process "What Are Process Chemistry CRO Services?" Section Endpoints
  getProcessWhatIsSection: "/process-what-is-section",
  updateProcessWhatIsSection: "/process-what-is-section",
  // Site Navigation Label Overrides
  getAllNavLabels: "/nav-labels",
  updateNavLabel: "/nav-labels",
  createVision: "/vision",
  getVision: "/vision",
  addClient: "/client/new",
  allClients: "/client/all",
  singleClient: "/client/one",
  updateClient: "/client/update",
  deleteClient: "/client/delete",
  addTestimonial: "/testimonial/new",
  getTestimonial: "/testimonial/all",
  deleteTestimonial: "/testimonial/delete",
  singleTestimonial: "/testimonial/one",
  editTestimonial: "/testimonial/update",
  getHomeTestimonialHeading: "/home-testimonial-heading",
  updateHomeTestimonialHeading: "/home-testimonial-heading",
  addArticles: "/artical ",
  getArticles: "/artical/all",
  deleteArticle: "/artical/delete",
  singleArticle: "/artical/show",
  editArticle: "/artical/update",
  settings: "/settings",
  getSettings: "/settings",
  getAboutExploreHeading: "/about-explore-heading",
  updateAboutExploreHeading: "/about-explore-heading",
  getAllAboutExploreLinks: "/about-explore-links/all",
  newAboutExploreLink: "/about-explore-links/new",
  updateAboutExploreLink: "/about-explore-links/update",
  deleteAboutExploreLink: "/about-explore-links/delete",
  createAboutBanner: "/about-us",
  getAboutBanner: "/about-us",
  createAboutUsCard: "/about-us-cards",
  getAboutUsCard: "/about-us-cards",
  createTimeline: "/timeline/new",
  getTimeline: "/timeline/all",
  singleTimeline: "/timeline/one",
  updateTimeline: "/timeline/update",
  deleteTimeline: "/timeline/delete",
  personnelBanner: "/teambanner",
  personnelCharacterized: "/p-characteristics",
  teamSectionConfig: "/team-section-config",
  getTeamMember: "/team/all",
  addTeamMember: "/team/new",
  singleTeamMember: "/team/one",
  updateTeamMember: "/team/update",
  deleteTeamMember: "/team/delete",
  operatingPhilosophy: "/operating-philosophy",
  getOpExploreHeading: "/op-explore-heading",
  updateOpExploreHeading: "/op-explore-heading",
  getAllOpExploreLinks: "/op-explore-links/all",
  newOpExploreLink: "/op-explore-links/new",
  updateOpExploreLink: "/op-explore-links/update",
  deleteOpExploreLink: "/op-explore-links/delete",
  operatingPhilosophyDiagram: "/operatingphilosophygraph/all",
  singleOperatingPhilosophyDiagram: "/operatingphilosophygraph/one",
  editOperatingPhilosophyDiagram: "/operatingphilosophygraph/update",
  getCustomChemicalSynthesis: "/customchemicalsynthesis/all",
  createCustomChemicalSynthesis: "/customchemicalsynthesis/new",
  singleCustomChemicalSynthesis: "/customchemicalsynthesis/one",
  updateCustomChemicalSynthesis: "/customchemicalsynthesis/update",
  deleteCustomChemicalSynthesis: "/customchemicalsynthesis/delete",
  expertiseIncludes: "/expertiseincludes",
  caseStudyTabs: "/casestudymain/all",
  singleCaseStudyTabs: "/casestudymain/one",
  editCaseStudyTabs: "/casestudymain/update",
  caseStudyGraphContent: "/case_study_graph_center",
  getCaseStudyDiagramData: "/case_study_graph/all",
  singleCaseStudyDiagramData: "/case_study_graph/one",
  editCaseStudyDiagramData: "/case_study_graph/update",
  testimonialPageHeading: "/testimonial2head",
  getTestimonialExploreHeading: "/testimonial-explore-heading",
  updateTestimonialExploreHeading: "/testimonial-explore-heading",
  getAllTestimonialExploreLinks: "/testimonial-explore-links/all",
  newTestimonialExploreLink: "/testimonial-explore-links/new",
  updateTestimonialExploreLink: "/testimonial-explore-links/update",
  deleteTestimonialExploreLink: "/testimonial-explore-links/delete",
  getAllTestimonial2: "/testimonial2/all",
  createTestimonial2: "/testimonial2/new",
  singleTestimonial2: "/testimonial2/one",
  editTestimonial2: "/testimonial2/update",
  deleteTestimonial2: "/testimonial2/delete",
  getTherapeuticsBanner: "/service-banner",
  updateTherapeuticsBanner: "/service-banner-update",
  supportTherapeutics: "/service-second",
  updateTherapeutics: "/service-second-update",
  allStepsTherapeutics: "/servicethird/all",
  singleStepsTherapeutics: "/servicethird/one",
  updateStepsTherapeutics: "/servicethird/update",
  serviceFeaturedImage: "/servicethirdfeatured",
  getAdcLinker: "/service-fourth",
  updateAdcLinker: "/service-fourth-update",
  getTherapeuticsBottom: "/service-fifth",
  editTherapeuticsBottom: "/service-fifth-update",
  carbohydrateBanner: "/complex-carbohydrate-banner",
  allCarbohydrateTimeline: "/complexcarboTimeline/all",
  createCarbohydrateTimeline: "/complexcarboTimeline/new",
  singleCarbohydrateTimeline: "/complexcarboTimeline/one",
  updateCarbohydrateTimeline: "/complexcarboTimeline/update",
  deleteCarbohydrateTimeline: "/complexcarboTimeline/delete",
  carbohydrateDescription: "/complex-carbohydrate-bottomTimeline",
  allCarbohydrateDiagram: "/complex-timeline-diagram/all",
  singleCarbohydrateDiagram: "/complex-timeline-diagram/one",
  editCarbohydrateDiagram: "/complex-timeline-diagram/update",
  employmentBanner: "/employment-banner",
  employmentResponsibilities: "/employmentAt",
  getEmploymentExploreHeading: "/employment-explore-heading",
  updateEmploymentExploreHeading: "/employment-explore-heading",
  getAllEmploymentExploreLinks: "/employment-explore-links/all",
  newEmploymentExploreLink: "/employment-explore-links/new",
  updateEmploymentExploreLink: "/employment-explore-links/update",
  deleteEmploymentExploreLink: "/employment-explore-links/delete",
  researchDevelopmentBanner: "/researchdevelopmentbanner",
  researchDevelopmentSort: "/researchdevelopmentsecond",
  getResearchTab: "/research-and-development/all",
  singleResearchTab: "/research-and-development/one",
  editResearchTab: "/research-and-development/update",
  allResumes: "/resume",
  deleteResume: "/resume/delete",
  chemistryExpertiseBanner: "/chemistryexpertisebanner",
  getAllChemistryTabs: "/chemistryexpertise/all",
  singleChemistryTabs: "/chemistryexpertise/one",
  createChemistryTabs: "/chemistryexpertise/new",
  updateChemistryTabs: "/chemistryexpertise/update",
  deleteChemistryTabs: "/chemistryexpertise/delete",
  resourceHeading: "/resourceshead",
  resourceUsefulGuides: "/resourceusefulguides",
  allResourcesTabs: "/resourcestabs/all",
  singleResourcesTabs: "/resourcestabs/one",
  updateResourcesTabs: "/resourcestabs/update",
  whitepaperBanner: "/whitepaperbanner",
  allWhitepapers: "/whitepaperblog/all",
  addWhitepaper: "/whitepaperblog/new",
  singleWhitepaper: "/whitepaperblog/one",
  editWhitepaper: "/whitepaperblog/update",
  deleteWhitepaper: "/whitepaperblog/delete",
  getCart: "/getCart",
  orders: "/orders",
  singleOrder: "/singleorder",
  conferenceBanner: "/conferencebanner",
  getAllConferencesCard: "/conferences/all",
  addConferencesCard: "/conferences/new",
  singleConferencesCard: "/conferences/one",
  editConferencesCard: "/conferences/update",
  deleteConferencesCard: "/conferences/delete",
  partnerBanner: "/partnersbanner",
  getAllPartnerCards: "/partnercasestudycard/all",
  getSinglePartnerCards: "/partnercasestudycard/one",
  editPartnerCards: "/partnercasestudycard/update",
  partnersbottom: "/partnersbottom",
  partnerFifthCard: "/partners_section_three",
  allPartnersLogo: "/partnerslogos/all",
  newPartnersLogo: "/partnerslogos/new",
  deletePartnersLogo: "/partnerslogos/delete",
  capabilitiesOverview: "/overviewbanner",
  analyticalInstrumentation: "/analytical-instrumentation",
  labEquipmentBanner: "/lab-equipment-banner",
  allLabEquipments: "/lab-equipment/all",
  singleLabEquipment: "/lab-equipment/one",
  addLabEquipment: "/lab-equipment/new",
  deleteLabEquipment: "/lab-equipment/delete",
  updateLabEquipment: "/lab-equipment/update",
  getAllCoupon: "/coupon-management/all",
  createCoupon: "/coupon-management/new",
  deleteCoupon: "/coupon-management/delete",
  singleCoupon: "/coupon-management/one",
  updateCoupon: "/coupon-management/update",
  getProcessTab: "/ProcessResearchDevelopment/all",
  addProcessTab: "/ProcessResearchDevelopment/new",
  singleProcessTab: "/ProcessResearchDevelopment/one",
  editProcessTab: "/ProcessResearchDevelopment/update",
  deleteProcessTab: "/ProcessResearchDevelopment/delete",
  processMidSection: "/ProcessResearchDevelopmentoneAbout",
  processBanner: "/ProcessResearchDevelopmentBanner",
  processResearchDiagram: "/ProcessResearchDiagram",
  smallMoleculeBanner: "/smdd-bannerBanner",
  smallHTS: "/smdd-hts",
  smallSBDD: "/smdd-sbdd",
  smallSAR: "/smdd-sar",
  scaffHolding: "/scaffold-hopping",
  smallLeadDevelopment: "/smdd-lead_development",
  getAllSmallMoleculeTabs: "/smdd-tabs/all",
  singleSmallMoleculeTabs: "/smdd-tabs/one",
  editSmallMoleculeTabs: "/smdd-tabs/update",
  isotopeBanner: "/isotope-banner",
  isotopeAssessment: "/isotope-assessment",
  getIsotopeTable: "/isotope-table/all",
  addIsotopeTable: "/isotope-table/new",
  singleIsotopeTable: "/isotope-table/one",
  updateIsotopeTable: "/isotope-table/update",
  deleteIsotopeTable: "/isotope-table/delete",
  isotopeDetails: "/isotope-details",
  isotopeButtons: "/isotope-buttons",
  projectManagementBanner: "/project_management-banner",
  projectManagementBottomDesc: "/project-management-footer",
  getAllProjectManagementList: "/project-management/all",
  addProjectManagementList: "/project-management/new",
  getSingleProjectManagementList: "/project-management/one",
  updateProjectManagementList: "/project-management/update",
  deleteProjectManagementList: "/project-management/delete",
  othersBanner: "/others-banner",
  allOthersList: "/others/all",
  addOtherList: "/others/new",
  singleOtherList: "/others/one",
  editOtherList: "/others/update",
  deleteOtherList: "/others/delete",
  overviewBanner: "/overview",
  allOverviewTab: "/overview-main/all",
  addOverviewTab: "/overview-main/new",
  singleOverviewTab: "/overview-main/one",
  editOverviewTab: "/overview-main/update",
  deleteOverviewTab: "/overview-main/delete",
  allAnalyticalInstrument: "/analytical-instrumentation-main/all",
  addAnalyticalInstrument: "/analytical-instrumentation-main/new",
  singleAnalyticalInstrument: "/analytical-instrumentation-main/one",
  editAnalyticalInstrument: "/analytical-instrumentation-main/update",
  deleteAnalyticalInstrument: "/analytical-instrumentation-main/delete",
  allSynthesis: "/synthesis-main/all",
  addSynthesis: "/synthesis-main/new",
  singleSynthesis: "/synthesis-main/one",
  editSynthesis: "/synthesis-main/update",
  deleteSynthesis: "/synthesis-main/delete",
  researchCollaborationBanner: "/research-collaboration-banner",
  researchCollaborationMidSection: "/research-collaboration-mid-section",
  researchCollaborationDiagram: "/research-collaboration-diagram",
  allResearchCollaborationAcademia: "/research-collaboration-academia/all",
  singleResearchCollaborationAcademia: "/research-collaboration-academia/one",
  editResearchCollaborationAcademia: "/research-collaboration-academia/update",
  allResearchCollaborationCompany: "/research-collaboration-company/all",
  singleResearchCollaborationCompany: "/research-collaboration-company/one",
  editResearchCollaborationCompany: "/research-collaboration-company/update",
  accreditations: "/accreditations",
  addAccreditations: "add-accreditations",
  singleAccreditatios: "/edit-accreditations",
  editAccreditations: "/accreditations-status",
  deleteAccreditations: "/delete-accreditations",
  footerUsefulLinks: "/menu-titles",
  footerMenuLinks: "/menu-items",
  addTestimonialClient: "/add-testimonial-logo",
  getTestimonialClient: "/logo-listing",
  deleteTestimonialClient: "/delete-testimonial-logo",
  allAdmin: "/list",
  createAdmin: "/create",
  deleteAdmin: "/delete",
  updateAdmin: "/update",
  updateAdminPassword: "/update-password",
  getStorageExploreHeading: "/storage-explore-heading",
  updateStorageExploreHeading: "/storage-explore-heading",
  getAllStorageExploreLinks: "/storage-explore-links/all",
  newStorageExploreLink: "/storage-explore-links/new",
  updateStorageExploreLink: "/storage-explore-links/update",
  deleteStorageExploreLink: "/storage-explore-links/delete",
  getProcessRdExploreHeading: "/process-rd-explore-heading",
  updateProcessRdExploreHeading: "/process-rd-explore-heading",
  getAllProcessRdExploreLinks: "/process-rd-explore-links/all",
  newProcessRdExploreLink: "/process-rd-explore-links/new",
  updateProcessRdExploreLink: "/process-rd-explore-links/update",
  deleteProcessRdExploreLink: "/process-rd-explore-links/delete",
  getLipidExploreHeading: "/lipid-explore-heading",
  updateLipidExploreHeading: "/lipid-explore-heading",
  getAllLipidExploreLinks: "/lipid-explore-links/all",
  newLipidExploreLink: "/lipid-explore-links/new",
  updateLipidExploreLink: "/lipid-explore-links/update",
  deleteLipidExploreLink: "/lipid-explore-links/delete",
  getAdcExploreHeading: "/adc-explore-heading",
  updateAdcExploreHeading: "/adc-explore-heading",
  getAllAdcExploreLinks: "/adc-explore-links/all",
  newAdcExploreLink: "/adc-explore-links/new",
  updateAdcExploreLink: "/adc-explore-links/update",
  deleteAdcExploreLink: "/adc-explore-links/delete",
  getSmddExploreHeading: "/smdd-explore-heading",
  updateSmddExploreHeading: "/smdd-explore-heading",
  getAllSmddExploreLinks: "/smdd-explore-links/all",
  newSmddExploreLink: "/smdd-explore-links/new",
  updateSmddExploreLink: "/smdd-explore-links/update",
  deleteSmddExploreLink: "/smdd-explore-links/delete",
  getCcsExploreHeading: "/ccs-explore-heading",
  updateCcsExploreHeading: "/ccs-explore-heading",
  getAllCcsExploreLinks: "/ccs-explore-links/all",
  newCcsExploreLink: "/ccs-explore-links/new",
  updateCcsExploreLink: "/ccs-explore-links/update",
  deleteCcsExploreLink: "/ccs-explore-links/delete",
  getOverviewExploreHeading: "/overview-explore-heading",
  updateOverviewExploreHeading: "/overview-explore-heading",
  getAllOverviewExploreLinks: "/overview-explore-links/all",
  newOverviewExploreLink: "/overview-explore-links/new",
  updateOverviewExploreLink: "/overview-explore-links/update",
  deleteOverviewExploreLink: "/overview-explore-links/delete",
  getChemExpertiseExploreHeading: "/chem-expertise-explore-heading",
  updateChemExpertiseExploreHeading: "/chem-expertise-explore-heading",
  getAllChemExpertiseExploreLinks: "/chem-expertise-explore-links/all",
  newChemExpertiseExploreLink: "/chem-expertise-explore-links/new",
  updateChemExpertiseExploreLink: "/chem-expertise-explore-links/update",
  deleteChemExpertiseExploreLink: "/chem-expertise-explore-links/delete",
  getProjectMgmtExploreHeading: "/project-mgmt-explore-heading",
  updateProjectMgmtExploreHeading: "/project-mgmt-explore-heading",
  getAllProjectMgmtExploreLinks: "/project-mgmt-explore-links/all",
  newProjectMgmtExploreLink: "/project-mgmt-explore-links/new",
  updateProjectMgmtExploreLink: "/project-mgmt-explore-links/update",
  deleteProjectMgmtExploreLink: "/project-mgmt-explore-links/delete",
  getResearchCollabExploreHeading: "/research-collab-explore-heading",
  updateResearchCollabExploreHeading: "/research-collab-explore-heading",
  getAllResearchCollabExploreLinks: "/research-collab-explore-links/all",
  newResearchCollabExploreLink: "/research-collab-explore-links/new",
  updateResearchCollabExploreLink: "/research-collab-explore-links/update",
  deleteResearchCollabExploreLink: "/research-collab-explore-links/delete",
  getCarboExploreHeading: "/carbo-explore-heading",
  updateCarboExploreHeading: "/carbo-explore-heading",
  getAllCarboExploreLinks: "/carbo-explore-links/all",
  newCarboExploreLink: "/carbo-explore-links/new",
  updateCarboExploreLink: "/carbo-explore-links/update",
  deleteCarboExploreLink: "/carbo-explore-links/delete",
  getOthersExploreHeading: "/others-explore-heading",
  updateOthersExploreHeading: "/others-explore-heading",
  getAllOthersExploreLinks: "/others-explore-links/all",
  newOthersExploreLink: "/others-explore-links/new",
  updateOthersExploreLink: "/others-explore-links/update",
  deleteOthersExploreLink: "/others-explore-links/delete",
  getIsotopeExploreHeading: "/isotope-explore-heading",
  updateIsotopeExploreHeading: "/isotope-explore-heading",
  getAllIsotopeExploreLinks: "/isotope-explore-links/all",
  newIsotopeExploreLink: "/isotope-explore-links/new",
  updateIsotopeExploreLink: "/isotope-explore-links/update",
  deleteIsotopeExploreLink: "/isotope-explore-links/delete",
  getSynthExploreHeading: "/synth-explore-heading",
  updateSynthExploreHeading: "/synth-explore-heading",
  getAllSynthExploreLinks: "/synth-explore-links/all",
  newSynthExploreLink: "/synth-explore-links/new",
  updateSynthExploreLink: "/synth-explore-links/update",
  deleteSynthExploreLink: "/synth-explore-links/delete",
  getAnalyticalExploreHeading: "/analytical-explore-heading",
  updateAnalyticalExploreHeading: "/analytical-explore-heading",
  getAllAnalyticalExploreLinks: "/analytical-explore-links/all",
  newAnalyticalExploreLink: "/analytical-explore-links/new",
  updateAnalyticalExploreLink: "/analytical-explore-links/update",
  deleteAnalyticalExploreLink: "/analytical-explore-links/delete",
  getPartnersExploreHeading: "/partners-explore-heading",
  updatePartnersExploreHeading: "/partners-explore-heading",
  getAllPartnersExploreLinks: "/partners-explore-links/all",
  newPartnersExploreLink: "/partners-explore-links/new",
  updatePartnersExploreLink: "/partners-explore-links/update",
  deletePartnersExploreLink: "/partners-explore-links/delete",
  getAccreditationsExploreHeading: "/accreditations-explore-heading",
  updateAccreditationsExploreHeading: "/accreditations-explore-heading",
  getAllAccreditationsExploreLinks: "/accreditations-explore-links/all",
  newAccreditationsExploreLink: "/accreditations-explore-links/new",
  updateAccreditationsExploreLink: "/accreditations-explore-links/update",
  deleteAccreditationsExploreLink: "/accreditations-explore-links/delete",
  getAnnArborExploreHeading: "/ann-arbor-explore-heading",
  updateAnnArborExploreHeading: "/ann-arbor-explore-heading",
  getAllAnnArborExploreLinks: "/ann-arbor-explore-links/all",
  newAnnArborExploreLink: "/ann-arbor-explore-links/new",
  updateAnnArborExploreLink: "/ann-arbor-explore-links/update",
  deleteAnnArborExploreLink: "/ann-arbor-explore-links/delete",
  getUsefulGuidesExploreHeading: "/useful-guides-explore-heading",
  updateUsefulGuidesExploreHeading: "/useful-guides-explore-heading",
  getAllUsefulGuidesExploreLinks: "/useful-guides-explore-links/all",
  newUsefulGuidesExploreLink: "/useful-guides-explore-links/new",
  updateUsefulGuidesExploreLink: "/useful-guides-explore-links/update",
  deleteUsefulGuidesExploreLink: "/useful-guides-explore-links/delete",
  getWhitepaperExploreHeading: "/whitepaper-explore-heading",
  updateWhitepaperExploreHeading: "/whitepaper-explore-heading",
  getAllWhitepaperExploreLinks: "/whitepaper-explore-links/all",
  newWhitepaperExploreLink: "/whitepaper-explore-links/new",
  updateWhitepaperExploreLink: "/whitepaper-explore-links/update",
  deleteWhitepaperExploreLink: "/whitepaper-explore-links/delete",
  getConferenceExploreHeading: "/conference-explore-heading",
  updateConferenceExploreHeading: "/conference-explore-heading",
  getAllConferenceExploreLinks: "/conference-explore-links/all",
  newConferenceExploreLink: "/conference-explore-links/new",
  updateConferenceExploreLink: "/conference-explore-links/update",
  deleteConferenceExploreLink: "/conference-explore-links/delete",
  getCatalogExploreHeading: "/catalog-explore-heading",
  updateCatalogExploreHeading: "/catalog-explore-heading",
  getAllCatalogExploreLinks: "/catalog-explore-links/all",
  newCatalogExploreLink: "/catalog-explore-links/new",
  updateCatalogExploreLink: "/catalog-explore-links/update",
  deleteCatalogExploreLink: "/catalog-explore-links/delete",
};
